import type React from 'react';

import I18nProvider from '@common/i18n/I18nProvider';
import useLocale from '@common/i18n/useLocale';
import createTheme from '@common/theme/createTheme';
import ThemeProvider from '@common/theme/ThemeProvider';
import type { LanguageCode } from '@common/types';

import SingletonProvider, { SingletonContext } from './SingletonProvider';

export type Props = {
  locale: LanguageCode;
  children?: React.ReactNode;
};

const Content = ({ children }: { children?: React.ReactNode }) => {
  const { direction } = useLocale();
  const theme = createTheme({ direction });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

/**
 * Setup the CDS theme and i18n for your application.
 * @see [Theming](__storybookUrl__/product-guidelines-engineering-themes--page#setup)
 */
const Provider = ({ children, locale }: Props) => (
  <SingletonProvider>
    <SingletonContext.Consumer>
      {(instances) => {
        return instances > 1 ? (
          children
        ) : (
          <I18nProvider locale={locale}>
            <Content>{children}</Content>
          </I18nProvider>
        );
      }}
    </SingletonContext.Consumer>
  </SingletonProvider>
);

export default Provider;
